import { computed } from "mobx";
import { RacingEventTypes } from "../../../data";
import { RacingStore, UtilsComposite } from "../../../data";
import { NextRacesEvent } from "./NextRaces";
import { RacingStateIds, RacingEventInfo } from "../../../data"
import { HRLineState } from "sb-resp-lib";
import { extendedPageMethodsComposite } from "../../RacingCombinedView/data";

/* TODO(developer): refactor to lower cyclomatic complexity */
/* tslint:disable:cyclomatic-complexity */
export type cmsOptionsComposition = { nextRacesCount: number, nextLinesCount: number };

export class RacingNextRacesData {
    public provider: extendedPageMethodsComposite;
    public racingStore: RacingStore;
    private betSlipUtil: BetSlipUtil;
    private nextRacesCount: number;
    private nextLinesCount: number;
    private oddsUtil: Odds;
    private racingGameNavigation: Function;
    constructor(provider: extendedPageMethodsComposite, utils: UtilsComposite, cmsOptionsComposition: cmsOptionsComposition, openRaceEvent: Function) {
        this.provider = provider;
        this.racingStore = RacingStore.getInstance;
        this.racingStore.webMethods = {
            pageMethods: provider.pageMethods,
            racingPageMethods: provider.racingPageMethods
        };
        this.racingStore.nextRacesCount = cmsOptionsComposition.nextRacesCount;
        this.racingGameNavigation = openRaceEvent;
        this.betSlipUtil = utils.betSlipUtil;
        this.oddsUtil = utils.oddsUtil;
        this.racingStore.setFacade(utils.facade);
        this.nextRacesCount = cmsOptionsComposition.nextRacesCount;
        this.nextLinesCount = cmsOptionsComposition.nextLinesCount;
    }

    // TODO: Remove when new event view is available
    /* istanbul ignore next */
    openRacingGame(
        racecardId: number,
        regionId: number,
        mode: number,
        branchId: number,
        trapMarketId: number,
        bettingWithoutFavId: number,
        bettingWithoutTwoFavId: number,
        placeOnlyId: number,
        matchBettingId: number,
        toteId: number,
        totePlaceOnlyId: number,
        auPlaceOnlyId: number,
        event: any): void {
        /* istanbul ignore next */
        this.racingGameNavigation(
            event,
            racecardId,
            regionId,
            mode,
            branchId,
            trapMarketId,
            bettingWithoutFavId,
            bettingWithoutTwoFavId,
            placeOnlyId,
            matchBettingId,
            toteId,
            totePlaceOnlyId,
            auPlaceOnlyId
        );
    }

    isLineInBetSlip(lineid: number, eventId: number): boolean {
        return this.betSlipUtil.isOddInSlip(0, eventId, lineid, 0, 0, 7, false, true);
    }

    getRacingMode(eventId: string) {
        if (this.racingStore.todaysEvents.find((x) => x.id === eventId)) {
            return 0;
        }
        else if (this.racingStore.tomorrowEvents.find((x) => x.id === eventId)) {
            return 1;
        }
        return 2;
    }

    @computed get getNextRaces(): NextRacesEvent[] {
        let nextRaces = this.racingStore.todaysEvents.concat(this.racingStore.tomorrowEvents);

        nextRaces = this.racingStore.sortEventByDate(nextRaces);

        let nextRacesAr: any[] = [];
        let evCount = 0;
        this.racingStore.oddstyleChaged; //Hack to redraw on oddstyle change.

        for (let i = 0; i < nextRaces.length; i += 1) {
            let masterEvent = nextRaces[i];

            /* istanbul ignore next */
            if (evCount === this.nextRacesCount) { break; }

            /* istanbul ignore next */
            if (masterEvent.raceProgress !== 0) { continue; }

            for (let index = 0; index < masterEvent.racingEvents.length; index++) {
                let ev: RacingEventInfo = masterEvent.racingEvents[index];

                /* istanbul ignore next */
                if (parseInt(ev.typeId) !== RacingEventTypes.RaceCard) { continue; }

                let lines: any[] = [];
                let count = 0;

                let sortedLines = ev.sortedLinesByOdds;

                for (let index = 0; index < sortedLines.length; index++) {
                    /* istanbul ignore next */
                    let line = sortedLines[index];

                    /* istanbul ignore next */
                    if (count === this.nextLinesCount) { break; }

                    /* istanbul ignore next */
                    let rcLine = ev.racecardLines.find((x) => x.lineId === line.id);

                    /* istanbul ignore next */
                    let showSP: boolean = ev.racingStateId === RacingStateIds.SP || (this.isLineSP(line.lineTypeId) && line.odds === 0);
                    let isWithdrawn = line.lineStateId === HRLineState.Withdrawn;
                    /* istanbul ignore next */
                    lines.push({
                        id: line.id,
                        eventId: ev.id,
                        src: rcLine ? rcLine.silkData : undefined,
                        isSP: showSP,
                        isNR: isWithdrawn,
                        odds: this.oddsUtil.convertFormat(line.odds,
                            parseInt(ev.typeId),
                            parseInt(line.lineTypeId),
                            undefined, undefined, undefined,
                            parseInt(ev.branchId),
                            `${line.fractOddsDividend}/${line.fractOddsDivisor}`),
                        fixture: {
                            top: line.lineName,
                            bottom: this.racingStore.branchId === 61 && rcLine ? `${rcLine.trainer} / ${rcLine.jockey}` : ""
                        },
                        handler: this.betSlipUtil.addQAOddHR.bind(this, 0, Number(ev.id), Number(line.id), line.odds, this.racingStore.regionId, ev.raceProgress, Number(ev.typeId))
                    });

                    count += 1;
                }

                let league = this.racingStore.leagues.find((x => x.masterLeagueId === ev.masterLeagueId));
                /* istanbul ignore next */
                let currentLeagueName = league ? league.name : "";
                let currentLeagueId = league ? league.id : "-1";
                evCount += 1;
                nextRacesAr.push(new NextRacesEvent({
                    id: ev.id,
                    date: ev.date,
                    hasLiveStream: ev.hasLiveStream,
                    leagueName: currentLeagueName,
                    rows: lines,
                    url: this.racingStore.getRacingEventUrl(ev.urlCode, currentLeagueId),
                    handler: this.openRacingGame.bind(
                        this,
                        this.racingStore.getMasterEventSpecificEventType(masterEvent, RacingEventTypes.RaceCard),
                        this.racingStore.regionId,
                        /* istanbul ignore next */
                        this.getRacingMode(masterEvent.id),
                        Number(this.racingStore.branch.id),
                        this.racingStore.getMasterEventSpecificEventType(masterEvent, RacingEventTypes.TrapMarket),
                        this.racingStore.getMasterEventSpecificEventType(masterEvent, RacingEventTypes.BettingWithoutFav),
                        this.racingStore.getMasterEventSpecificEventType(masterEvent, RacingEventTypes.BettingWithoutTwoFav),
                        this.racingStore.getMasterEventSpecificEventType(masterEvent, RacingEventTypes.PlaceOnly),
                        this.racingStore.getMasterEventSpecificEventType(masterEvent, RacingEventTypes.MatchBetting),
                        this.racingStore.getMasterEventSpecificEventType(masterEvent, RacingEventTypes.AUHRTote),
                        this.racingStore.getMasterEventSpecificEventType(masterEvent, RacingEventTypes.AUHRTotePlaceOnly),
                        this.racingStore.getMasterEventSpecificEventType(masterEvent, RacingEventTypes.AUHRPlaceOnly)
                    )
                }));
            }
        }

        return nextRacesAr;
    }

    // TODO: Create Util for lines validations
    /* istanbul ignore next */
    private isLineSP(lineTypeId: string): boolean {
        switch (parseInt(lineTypeId)) {
            case 24:
            case 25:
            case 26:
            case 27:
            case 28:
            case 29:
                /* istanbul ignore next */
                return true;
            default:
                /* istanbul ignore next */
                return false;
        }
    }

    @computed get isDataLoaded(): boolean {
        return !this.racingStore.isDataLoading;
    }

    // private resolve(res) {
    // }

    // private reject(res) {
    // }

    setParams(regionId: number, branchId: number) {
        this.racingStore.setParams(regionId, branchId);
    }

}